export default __webpack_public_path__ + "static/mur-59b262fbe5aa5f2e2eab119f1ca8674c.jpg";